<template>
    <div>
  <GmapMap ref="gmap"
    :center="{lat: 20.5937, lng: 78.9629}"
    :zoom="16"
    map-type-id="roadmap"
    style="width: 100%; height: 525px !important"
    :options="{
        mapTypeControl: false
    }"
    >
  </GmapMap>
  </div>
</template>

<script>
import { eventBus } from "../../../services";

export default {
  name: "KmlView",
  props: ['user'],
  data () {
    return {
      uri: ''
    }
  },
  methods: {
    },
    mounted() {
      // eventBus.$off("routeFileUri");
      eventBus.$on("routeFileUri",(data) => {
        this.uri = data;           
        this.$refs.gmap.$mapPromise.then((map) => {
          let options = {
            map: map,
            url: this.uri,
          }
          let kml = new google.maps.KmlLayer(options);
          google.maps.event.addListener(kml, 'status_changed', function() {
          
            })
            kml.setMap(map);
        });
    })
    eventBus.$emit("routeFileUriWasteCollection", {});
    eventBus.$emit("routeFileUriPrimary", {});
    
  },
  beforeDestroy () {
    eventBus.$off("routeFileUri")
  }
}
</script>



// WEBPACK FOOTER //
// kmlView.vue?c49657fc